export const matchWordListParagraph = (node: HTMLElement, delta: any): any => {
  const marker = (node.textContent ?? '').match(
    /^\s*(?:(\d+)[.)]|[\u00B7\u2022])\s*/,
  );
  if (marker == null) {
    return delta;
  }

  const result = delta.slice(marker[0].length);
  const level = Number(node.getAttribute('style')?.match(/level(\d+)/)?.[1]);
  const attributes = {
    list: marker[1] == null ? 'bullet' : 'ordered',
    ...(level > 1 ? { indent: level - 1 } : {}),
  };

  for (let index = result.ops.length - 1; index >= 0; index -= 1) {
    const operation = result.ops[index];
    if (
      typeof operation.insert === 'string' &&
      operation.insert.includes('\n')
    ) {
      operation.attributes = { ...operation.attributes, ...attributes };
      break;
    }
  }

  return result;
};
